import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import LabelGenerationActions, { labelGenerationActionTypes } from '../../actions/configurations/labelGenerationActions';
import LabelGenerationServices from '../../services/configurations/labelGenerationServices';

function* _updateLabelGeneration(action) {
  try {
    yield put(LabelGenerationActions.updateLabelGenerationLoading(true));
    const { payload } = action;
    const labelGeneration = yield LabelGenerationServices.updateLabelGeneration(payload);
    if (!labelGeneration.success) {
      notification.open({
        type: 'error',
        message: labelGeneration?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'Label generation updated successful.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(LabelGenerationActions.updateLabelGenerationLoading(false));
  } catch (error) {
    yield put(LabelGenerationActions.updateLabelGenerationLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* updateLabelGeneration() {
  yield takeLatest(labelGenerationActionTypes.UPDATE_LABEL_GENERATION.REQUEST, _updateLabelGeneration);
}

function* _getLabelGeneration(action) {
  const {
    payload, callback,
  } = action;
  try {
    LabelGenerationActions.getLabelGenerationSuccess(null);
    yield put(LabelGenerationActions.getLabelGenerationLoading(true));
    const labelGeneration = yield LabelGenerationServices.getLabelGeneration(payload);
    yield put(LabelGenerationActions.getLabelGenerationSuccess(labelGeneration?.data));
    if (callback) action.callback(labelGeneration);
    yield put(LabelGenerationActions.getLabelGenerationLoading(false));
  } catch (error) {
    yield put(LabelGenerationActions.getLabelGenerationLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getLabelGeneration() {
  yield takeLatest(labelGenerationActionTypes.GET_LABEL_GENERATION.REQUEST, _getLabelGeneration);
}

function* _getGlobalLabels(action) {
  const {
    payload, callback,
  } = action;
  try {
    LabelGenerationActions.getGlobalLabelsSuccess(null);
    yield put(LabelGenerationActions.getGlobalLabelsLoading(true));
    const globalLabels = yield LabelGenerationServices.getGlobalLabels(payload);
    yield put(LabelGenerationActions.getGlobalLabelsSuccess(globalLabels?.data));
    if (callback) action.callback(globalLabels);
    yield put(LabelGenerationActions.getGlobalLabelsLoading(false));
  } catch (error) {
    yield put(LabelGenerationActions.getGlobalLabelsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getGlobalLabels() {
  yield takeLatest(labelGenerationActionTypes.GET_GLOBAL_LABELS.REQUEST, _getGlobalLabels);
}

function* _createLabel(action) {
  const {
    payload, callback,
  } = action;
  try {
    yield put(LabelGenerationActions.createLabelLoading(true));
    const createdLabels = yield LabelGenerationServices.createLabel(payload);
    if (!createdLabels.success) {
      notification.open({
        type: 'error',
        message: createdLabels?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: createdLabels?.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (callback) action.callback(createdLabels);
    yield put(LabelGenerationActions.createLabelLoading(false));
  } catch (error) {
    yield put(LabelGenerationActions.createLabelLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* createLabel() {
  yield takeLatest(labelGenerationActionTypes.CREATE_LABEL.REQUEST, _createLabel);
}

function* _deleteLabel(action) {
  const {
    payload, callback,
  } = action;
  try {
    yield put(LabelGenerationActions.deleteLabelLoading(true));
    const deletedLabels = yield LabelGenerationServices.deleteLabel(payload);
    if (!deletedLabels.success) {
      notification.open({
        type: 'error',
        message: deletedLabels?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: deletedLabels?.message,
        duration: 4,
        placement: 'top',
      });
    }
    if (callback) action.callback(deletedLabels);
    yield put(LabelGenerationActions.deleteLabelLoading(false));
  } catch (error) {
    yield put(LabelGenerationActions.deleteLabelLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* deleteLabel() {
  yield takeLatest(labelGenerationActionTypes.DELETE_LABEL.REQUEST, _deleteLabel);
}

export default function* LabelGenerationSaga() {
  yield all([
    getLabelGeneration(), updateLabelGeneration(), getGlobalLabels(), createLabel(), deleteLabel(),
  ]);
}
